<div
  class="activity-card"
  [ngClass]="activityCardClass"
  [class.activity-card__print]="isPrint"
  [class.activity-card__waiting]="waitingValidation"
  [class.activity-card__canceled]="hasBeenCanceled"
>
  <div class="activity-card__content">
    <img alt="" class="activity-card__image" [src]="picture" />

    <span *ngIf="hasBeenCanceled" class="activity-card__content__tooltip">
      <span class="activity-card__content__tooltip__text">
        {{ 'component.activity_card.status.canceled.tooltip' | translate }}
      </span>
      <span class="vtmx-information-line"></span>
    </span>

    <div class="activity-card__info-container">
      <p *ngIf="hasTopText" class="activity-card__custom-content">
        <ng-content select="[top-text]"></ng-content>
      </p>

      <p class="activity-card__title">
        {{ title }}
      </p>

      <p *ngIf="!isLive && address" class="activity-card__address">
        {{ address }}
      </p>

      <p *ngIf="hasBottomText" class="activity-card__custom-content">
        <ng-content select="[bottom-text]"></ng-content>
      </p>

      <div class="flex flex-wrap">
        <app-badge
          *ngIf="displayPrice"
          class="activity-card__price"
          [variant]="badgeVariant.YELLOW"
        >
          <ng-container *ngIf="!isStartingPrice">
            {{ price | displayPrice: currency : maxPrice }}
          </ng-container>

          <ng-container *ngIf="isStartingPrice">
            {{ price | displayStartingPrice: currency }}
          </ng-container>
        </app-badge>


        <app-badge
          *ngIf="duration"
          class="activity-card__duration"
          [variant]="badgeVariant.GREY_LIGHT"
        >
          {{ duration }}
        </app-badge>

        <app-badge
          *ngIf="isLive"
          class="activity-card__live"
          [variant]="badgeVariant.GREY_LIGHT"
          [icon]="icon.Video"
          iconClass="text-red"
        >
          {{ 'component.activity_card.live' | translate }}
        </app-badge>

        <app-badge
          *ngIf="isPrivate"
          class="activity-card__visibility"
          [variant]="badgeVariant.GREY_LIGHT"
          [icon]="icon.EyeOff"
        >
          {{ 'component.activity_card.private' | translate }}
        </app-badge>

        <app-badge
          *ngIf="attendees"
          class="activity-card__attendees"
          [icon]="icon.User"
          [variant]="badgeVariant.GREY_LIGHT"
        >
          {{ attendees.total }}/{{ attendees.max }}
        </app-badge>
      </div>

      <div *ngIf="activityHasQrcode" class="activity-card__qrcode">
        <vtmn-play-icon
          [name]="icon.QrCode"
          [height]="18"
          [width]="18"
          class="activity-card__qrcode__icon"
        ></vtmn-play-icon>
        <span class="activity-card__qrcode__label">
          {{ scansTotal }}/{{ expectedCustomers }}
          {{ 'component.activity_card.qrcode' | translate }}
        </span>
      </div>

      <ng-container>
        <app-vtmn-rating
          *ngIf="reviewsStats?.count > 0"
          [compact]="true"
          [showValue]="true"
          [value]="reviewsStats?.averageRating"
          [comments]="
            'activity.reviews.count-reviews'
              | translate: { reviewQuantity: reviewsStats?.count?.toString() }
          "
          [size]="ratingSizeEnum.SMALL"
          [emphasis]="true"
          [maxValue]="false"
        ></app-vtmn-rating>
      </ng-container>
    </div>
    <button
      *ngIf="hasDropDown && !waitingValidation"
      app-vtmn-play-icon-button
      type="button"
      class="activity-card__arrow"
      [class.activity-card__arrow--active]="isOpened"
      [variant]="vtmnPlayButtonVariant.TERTIARY"
      (click)="toggle()"
    >
      <vtmn-play-icon [name]="icon?.ChevronDown"></vtmn-play-icon>
    </button>
  </div>

  <div
    *ngIf="hasDropDown && isOpened"
    @toggle
    class="activity-card__dropdown"
    [class.activity-card__dropdown__waiting]="waitingValidation"
  >
    <ng-content select="[drop-down]"></ng-content>
  </div>

  <div *ngIf="waitingValidation" class="activity-card__image-overlay">
    <p
      class="inline-block mt-4 border-b-4 font-condensed italic font-bold transform skew-x-decathlon"
      [class.activity-card__image-overlay--waiting]="waitingValidation"
    >
      {{ 'component.activity_card.status.' + type | translate }}
    </p>
  </div>
</div>
